var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full pt-0",class:{ 'sm:w-1/4 sm:text-right': !_vm.vertical, 'sm:pt-2': !_vm.inline }},[_vm._t("label")],2),_c('div',{staticClass:"vx-col w-full",class:{ 'sm:w-3/4 ': !_vm.vertical }},[_vm._t("field")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }